import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import { useStaticQuery, graphql } from "gatsby";
import BookValuation from '../Home/BookValuation/BookValuation';


const PropertyHelp = (props) => {

  const data = useStaticQuery(graphql`
  query {
    glstrapi {
        globalModule {
            Property_Details_Help_Module {
              Name
              Show_Chart
              Content
              CTA_2_Label
              CTA_1_Label
              CTA_1_Link {
                id
              }
              CTA_2_Link {
                id
              }
              Select_Form {
                Select
              }
            }
        }
    }
  }
`);

  const module = data.glstrapi.globalModule.Property_Details_Help_Module;

  return (
    <React.Fragment>
      {module &&
        <div className="property-details-help-module">
          <BookValuation {...module} />
        </div>
      }
    </React.Fragment>
  )
}

export default PropertyHelp;